import { useNavigate, useRouteLoaderData } from "react-router-dom";
import { useTheme } from "@mui/material";
import { RootLoader } from "@/types/RootLoader";
import { WorkflowPageProps } from "./Workflow.types";

const useWorkflow = (props: WorkflowPageProps) => {
  const { page } = props;
  const appName = "tinyAlbert" as const;
  const theme = useTheme();
  const { accountInfo } = useRouteLoaderData("root") as RootLoader;

  const navigate = useNavigate();
  const quitApp = () => {
    navigate("/main/workflows");
  };

  const navigateTo = (path: string) => {
    navigate(path);
  };

  const config = {
    appName,
    theme,
    page,
    quitApp,
    baseUrl: import.meta.env.VITE_APP_API_URL || "",
    navigateTo,
    accountId: accountInfo?.id,
    currency: accountInfo?.currency,
    shopifyIntegration: true,
    userFullName: `${accountInfo?.firstName ?? ""} ${
      accountInfo?.lastName ?? ""
    }`.trim(),
  };
  return { config };
};

export default useWorkflow;
